module.exports = __webpack_public_path__ + "static/media/striped_bar_M2_tall.3d60be0a.svg";